export default __webpack_public_path__ + "static/media/vietnam_offshore_wind.e1e2e42b.png";